<template>
    <div class="panel-container">
        <div>
            <button id="back-button" class="unstyled-button" @click="goToKeys">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="#051C2E">
                    <path d="M12 19.625 4.375 12 12 4.375l1.075 1.075-5.825 5.8h12.375v1.5H7.25l5.825 5.8Z"/>
                </svg>
                Authentication keys
            </button>
            <button class="unstyled-button close-button" @click="this.$router.push('/projects')">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="#051C2E">
                    <path d="M6.4 18.65 5.35 17.6l5.6-5.6-5.6-5.6L6.4 5.35l5.6 5.6 5.6-5.6 1.05 1.05-5.6 5.6 5.6 5.6-1.05 1.05-5.6-5.6Z"/>
                </svg>
            </button>
        </div>
        <div v-if="loading" class="sk-circle-container">
            <div class="sk-circle">
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
            </div>
        </div>
        <div v-else-if="!loading && !loadingError" id="key-text">
            <h2>Access key details</h2>
            <KeyDetails
                :access_key="keyDetails.key.access_key"
                :secret_key="keyDetails.key.secret_key"
                :key_desc="keyDetails.key.user_note"
                :prjnum="keyDetails.project.prjnum"
                :prj_desc="keyDetails.project.title"
                :key_owner="keyDetails.user"
                :created="keyDetails.key.created"
                :expire="keyDetails.key.expire"
            />
            <KeyExtension
                :prjnum="keyDetails.project.prjnum" 
                :access_key="keyDetails.key.access_key"
                :time_left="keyDetails.key.time_left"
                @key-extended="getKeyDetails(false)"
            />
            <ConfigGeneration 
                :prjnum="keyDetails.project.prjnum"
                :access_key="keyDetails.key.access_key"
            />
            <KeyDeletion 
                :prjnum="keyDetails.project.prjnum"
                :access_key="keyDetails.key.access_key"
            />
            <DeletionModal />
        </div>
        <div v-else id="loading-error">
            <p>Error loading key details</p>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import KeyDetails from './KeyDetails.vue';
import KeyExtension from './KeyExtension.vue';
import ConfigGeneration from './ConfigGeneration.vue';
import KeyDeletion from './KeyDeletion.vue';
import DeletionModal from './DeletionModal.vue';


export default {
    name: 'SingleKeyPanel',
    props: ['prjnum', 'keynum'],
    components: { 
        KeyDetails,
        KeyExtension,
        ConfigGeneration,
        KeyDeletion,
        DeletionModal
    },
    data() {
        return {
            loading: Boolean,
            loadingError : false,
            keyDetails: {},
        }
    },
    methods: {
        getKeyDetails(showLoadingIcon) {
            if (showLoadingIcon) this.loading = true;
            let url = '/api/v1/project/' + this.prjnum + '/key/' + this.keynum;
            axios.get(url)
            .then((response) => {
                this.keyDetails = response.data;
                this.loading = false;
                this.loadingError = false;

            })
            .catch(error => { 
                console.log(error.response.status, error.response.statusText);
                this.loading = false;
                this.loadingError = true;
            });
        },
        goToKeys() {
            this.$router.push('/projects/' + this.prjnum);
        }
    },
    created() {
        this.getKeyDetails(true);
    },
    mounted() {
        this.emitter.on('active-key-deleted', this.goToKeys);
    },
    beforeUnmount() {
        this.emitter.off('active-key-deleted', this.goToKeys);
    }
}

</script>

<style scoped>

#back-button {
    width: fit-content;
    display: inline-flex;
    margin-top: 1.5rem;
}

#alert-wrapper {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

#key-text, #loading-error {
    padding: 0 1.5rem;
    
}

</style>